module.exports = __webpack_public_path__ + "img/77.804fc124.jpg";